export default "\r\n<div>\r\n    <file-upload [multiple]=\"false\" [filter]=\"filter\" (output)=\"fileUploaded($event)\"></file-upload>\r\n</div>\r\n"